<p-menubar
  [model]="menuItems"
  [pt]="menubarPt()"
  styleClass="app-header sticky top-0 h-auto desktop:h-[60px] flex-col desktop:flex-row desktop:items-center"
>
  <ng-template #start>
    <!-- Placed in the menubar's #start slot (not #end, which PrimeNG pushes to the far
         right via `.p-menubar-end { margin-left: auto }`) so the search sits at the left
         of the header instead of huddled next to the profile.

         One wrapping flex row rather than a stacked pair of rows, because the projected
         controls have to appear on the logo/hamburger row on mobile but beside the search
         on desktop — and a single <ng-content> cannot be projected into two places, so the
         same element has to be repositioned by CSS instead of duplicated.

         Mobile: the search's w-full forces it onto its own line, leaving
         logo | hamburger toggle above it. Desktop: the hamburger is hidden (the sidebar
         takes over) and flex-nowrap keeps logo + search + toggle on one line, with
         `order` restoring the search-then-toggle reading order that DOM order reverses
         for the wrap to work.

         The logo is mobile-only: on desktop the sidebar header owns the mark (wordmark
         when expanded, icon mark on the collapsed rail), so showing it here too doubles
         it up. -->
    <div
      class="header-start flex flex-wrap items-center gap-x-3 gap-y-2 w-full desktop:w-auto desktop:flex-nowrap"
    >
      <div class="app-logo desktop:hidden">
        <a [href]="homeLink()">
          <img src="/assets/img/nymbl_dot.svg" alt="nymbl." class="h-8" />
        </a>
      </div>

      @if (!guestUser()) {
        <!-- ml-auto lives on this wrapper, not the p-button's styleClass, so the margin
             lands on the flex item itself and actually pushes it (and the toggle after
             it) to the right edge of the row. -->
        <div class="ml-auto desktop:hidden">
          <p-button
            icon="pi pi-bars"
            [text]="true"
            [rounded]="true"
            (onClick)="toggleDrawer()"
            ariaLabel="Toggle navigation menu"
            [attr.aria-expanded]="drawerVisible()"
            styleClass="hamburger-button"
          >
          </p-button>
        </div>
      }

      @if (user() && !guestUser()) {
        <!-- Content projection slot for version toggle or other controls -->
        <div class="header-controls desktop:order-2">
          <ng-content select="[topbarControls]" />
        </div>

        <div
          class="header-search w-full desktop:order-1 desktop:w-[26rem]"
        >
          <app-patient-search (patientSelect)="navigateToPatient($event)" />
        </div>
      }
    </div>
  </ng-template>

  <ng-template #end>
    @if (user()) {
      <div
        class="header-end flex flex-col desktop:flex-row desktop:items-center gap-2 desktop:gap-4 w-full desktop:w-auto desktop:ml-auto"
      >
        <!-- Company selection stays a directly visible control, deliberately outside the
             profile overlay: it is a separate concern with its own change-company flow,
             and the profile menu sits to its right. Logout no longer has its own button
             here — it moved into the overlay. -->
        <div class="user-section flex items-center justify-end gap-4">
          @if (user()?.isSuperAdmin || user()?.isMultiUser) {
            <app-main-company-selector
              [user]="user()"
              [selectedCompany]="selectedCompany()"
            >
            </app-main-company-selector>
          }

          <app-notification-bell
            [userId]="user()?.id ?? null"
            [userName]="notificationSenderName()"
          />

          <app-user-profile-menu [user]="user()!" />
        </div>
      </div>
    } @else if (guestUser()) {
      <div class="user-details flex flex-col items-end w-full desktop:w-auto">
        <span class="user-name"
          >{{ guestUser()?.firstName }} {{ guestUser()?.lastName }}</span
        >
        <span class="user-email">{{ guestUser()?.email }}</span>
      </div>
    }
  </ng-template>
</p-menubar>
